"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var viewBox = '1 0 14 15';

var SuccessCircle = function SuccessCircle() {
  return _react["default"].createElement("path", {
    d: "M11.287,4.7045 C10.272,6 8.1395,9.843 7.317,11.504 C7.2035,11.732 6.971,11.876 6.717,11.876 C6.712,11.876 6.706,11.876 6.7,11.8755 C6.44,11.869 6.2075,11.7125 6.1035,11.4735 C5.752,10.665 4.612,8.941 4.2515,8.6665 C3.9395,8.533 3.773,8.182 3.8765,7.8515 C3.986,7.499 4.3615,7.301 4.714,7.4125 C5.2875,7.591 6.124,8.8115 6.7,9.78 C7.71,7.877 9.3275,5.0355 10.234,3.8795 C10.4615,3.5885 10.882,3.537 11.173,3.765 C11.464,3.993 11.515,4.4135 11.287,4.7045 M7.6375,0.5 C3.6955,0.5 0.5,3.6955 0.5,7.6375 C0.5,11.58 3.6955,14.7755 7.6375,14.7755 C11.5795,14.7755 14.7755,11.58 14.7755,7.6375 C14.7755,3.6955 11.5795,0.5 7.6375,0.5"
  });
};

var _default = (0, _createSvgIcon["default"])(SuccessCircle, {
  viewBox: viewBox
});

exports["default"] = _default;